module.exports = __webpack_public_path__ + "img/user-08.d01a17e3.jpg";